import React from 'react';
import PlaceHolder from '../PlaceHolder/placeHolder';


class CardInfo extends React.Component{

    render(){

      return (
        <div className="jumbotron all-placeholder-div">
          <PlaceHolder style="placeHolder-wrapper card-margin" />
          <PlaceHolder style="placeHolder-wrapper card-margin" />
          <PlaceHolder style="placeHolder-wrapper" />
        </div>
      );
    }

}

export default CardInfo;



// WEBPACK FOOTER //
// ./src/components/Offers/card_placeholder.js